import { render, staticRenderFns } from "./SnapCard.vue?vue&type=template&id=d86bf874&"
import script from "./SnapCard.vue?vue&type=script&lang=js&"
export * from "./SnapCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d86bf874')) {
      api.createRecord('d86bf874', component.options)
    } else {
      api.reload('d86bf874', component.options)
    }
    module.hot.accept("./SnapCard.vue?vue&type=template&id=d86bf874&", function () {
      api.rerender('d86bf874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SnapCard.vue"
export default component.exports